export default __webpack_public_path__ + "static/media/off.925a2f30.svg";